import React, { useRef, useState, useEffect } from 'react';
import LetterCanvas from './LetterCanvas';

const randonLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const letters = [
    {
        image: '/letter-direction/a.png',
        strokes: [
            { start: { x: 150, y: 20 }, end: { x: 80, y: 280 } },
            { start: { x: 150, y: 20 }, end: { x: 220, y: 280 } },
            { start: { x: 110, y: 160 }, end: { x: 190, y: 160 } }
        ]
    },
    {
        image: '/letter-direction/b.png',
        strokes: [
            { start: { x: 80, y: 20 }, end: { x: 80, y: 280 } },
            { start: { x: 80, y: 20 }, end: { x: 180, y: 100 } },
            { start: { x: 80, y: 140 }, end: { x: 180, y: 240 } }
        ]
    },
    {
        image: '/letter-direction/c.png',
        strokes: [
            { start: { x: 200, y: 40 }, end: { x: 100, y: 150 } },
            { start: { x: 100, y: 150 }, end: { x: 200, y: 260 } }
        ]
    },
    {
        image: '/letter-direction/d.png',
        strokes: [
            { start: { x: 80, y: 20 }, end: { x: 80, y: 280 } },
            { start: { x: 80, y: 20 }, end: { x: 200, y: 150 } },
            { start: { x: 200, y: 150 }, end: { x: 80, y: 280 } }
        ]
    },
    {
        image: '/letter-direction/e.png',
        strokes: [
            { start: { x: 200, y: 20 }, end: { x: 80, y: 20 } },
            { start: { x: 80, y: 20 }, end: { x: 80, y: 280 } },
            { start: { x: 80, y: 150 }, end: { x: 160, y: 150 } },
            { start: { x: 80, y: 280 }, end: { x: 200, y: 280 } }
        ]
    },
    {
        image: '/letter-direction/f.png',
        strokes: [
            { startX: 80, startY: 50, endX: 80, endY: 250 },
            { startX: 80, startY: 50, endX: 200, endY: 50 },
            { startX: 80, startY: 150, endX: 160, endY: 150 }
        ]
    },
    {
        image: '/letter-direction/g.png',
        strokes: [
            { startX: 200, startY: 80, endX: 80, endY: 150 },
            { startX: 80, startY: 150, endX: 200, endY: 250 },
            { startX: 200, startY: 250, endX: 130, endY: 250 },
            { startX: 130, startY: 250, endX: 130, endY: 190 }
        ]
    },
    {
        image: '/letter-direction/h.png',
        strokes: [
            { startX: 80, startY: 50, endX: 80, endY: 250 },
            { startX: 200, startY: 50, endX: 200, endY: 250 },
            { startX: 80, startY: 150, endX: 200, endY: 150 }
        ]
    },
    {
        image: '/letter-direction/i.png',
        strokes: [
            { startX: 120, startY: 50, endX: 180, endY: 50 },
            { startX: 150, startY: 50, endX: 150, endY: 250 },
            { startX: 120, startY: 250, endX: 180, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/j.png',
        strokes: [
            { startX: 200, startY: 50, endX: 200, endY: 200 },
            { startX: 200, startY: 200, endX: 140, endY: 250 },
            { startX: 140, startY: 250, endX: 100, endY: 200 }
        ]
    },
    {
        image: '/letter-direction/k.png',
        strokes: [
            { startX: 80, startY: 50, endX: 80, endY: 250 },
            { startX: 200, startY: 50, endX: 80, endY: 150 },
            { startX: 80, startY: 150, endX: 200, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/l.png',
        strokes: [
            { startX: 80, startY: 50, endX: 80, endY: 250 },
            { startX: 80, startY: 250, endX: 200, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/m.png',
        strokes: [
            { startX: 80, startY: 250, endX: 80, endY: 50 },
            { startX: 80, startY: 50, endX: 150, endY: 150 },
            { startX: 150, startY: 150, endX: 220, endY: 50 },
            { startX: 220, startY: 50, endX: 220, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/n.png',
        strokes: [
            { startX: 80, startY: 250, endX: 80, endY: 50 },
            { startX: 80, startY: 50, endX: 220, endY: 250 },
            { startX: 220, startY: 250, endX: 220, endY: 50 }
        ]
    },
    {
        image: '/letter-direction/o.png',
        strokes: [
            { startX: 150, startY: 50, endX: 80, endY: 150 },
            { startX: 80, startY: 150, endX: 150, endY: 250 },
            { startX: 150, startY: 250, endX: 220, endY: 150 },
            { startX: 220, startY: 150, endX: 150, endY: 50 }
        ]
    },
    {
        image: '/letter-direction/p.png',
        strokes: [
            { startX: 80, startY: 50, endX: 80, endY: 250 },
            { startX: 80, startY: 50, endX: 200, endY: 130 },
            { startX: 200, startY: 130, endX: 80, endY: 130 }
        ]
    },
    {
        image: '/letter-direction/q.png',
        strokes: [
            { startX: 150, startY: 50, endX: 80, endY: 150 },
            { startX: 80, startY: 150, endX: 150, endY: 250 },
            { startX: 150, startY: 250, endX: 220, endY: 150 },
            { startX: 220, startY: 150, endX: 150, endY: 50 },
            { startX: 180, startY: 200, endX: 230, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/r.png',
        strokes: [
            { startX: 80, startY: 50, endX: 80, endY: 250 },
            { startX: 80, startY: 50, endX: 200, endY: 130 },
            { startX: 200, startY: 130, endX: 80, endY: 130 },
            { startX: 80, startY: 130, endX: 200, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/s.png',
        strokes: [
            { startX: 200, startY: 50, endX: 80, endY: 100 },
            { startX: 80, startY: 100, endX: 200, endY: 200 },
            { startX: 200, startY: 200, endX: 80, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/t.png',
        strokes: [
            { startX: 80, startY: 50, endX: 220, endY: 50 },
            { startX: 150, startY: 50, endX: 150, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/u.png',
        strokes: [
            { startX: 80, startY: 50, endX: 80, endY: 200 },
            { startX: 80, startY: 200, endX: 220, endY: 200 },
            { startX: 220, startY: 200, endX: 220, endY: 50 }
        ]
    },
    {
        image: '/letter-direction/v.png',
        strokes: [
            { startX: 80, startY: 50, endX: 150, endY: 250 },
            { startX: 150, startY: 250, endX: 220, endY: 50 }
        ]
    },
    {
        image: '/letter-direction/w.png',
        strokes: [
            { startX: 80, startY: 50, endX: 110, endY: 250 },
            { startX: 110, startY: 250, endX: 150, endY: 150 },
            { startX: 150, startY: 150, endX: 190, endY: 250 },
            { startX: 190, startY: 250, endX: 220, endY: 50 }
        ]
    },
    {
        image: '/letter-direction/x.png',
        strokes: [
            { startX: 80, startY: 50, endX: 220, endY: 250 },
            { startX: 220, startY: 50, endX: 80, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/y.png',
        strokes: [
            { startX: 80, startY: 50, endX: 150, endY: 150 },
            { startX: 220, startY: 50, endX: 150, endY: 150 },
            { startX: 150, startY: 150, endX: 150, endY: 250 }
        ]
    },
    {
        image: '/letter-direction/z.png',
        strokes: [
            { startX: 80, startY: 50, endX: 220, endY: 50 },
            { startX: 220, startY: 50, endX: 80, endY: 250 },
            { startX: 80, startY: 250, endX: 220, endY: 250 }
        ]
    },
];

const LetterDrawingComp = ({ type }) => {
    const [completed, setCompleted] = useState(false);
    const [score, setScore] = useState(0);
    const [volume, setVolume] = useState(1);
    const [isMuted, setIsMuted] = useState(false);
    const [message, setMessage] = useState('');
    const [index, setIndex] = useState(0);
    const [letterOrder, setLetterOrder] = useState([]);
    const [scoreAnim, setScoreAnim] = useState(false);

    // For dynamic/random order
    useEffect(() => {
        if (type === "random" || type === "dynamic") {
            const shuffled = [...randonLetters].sort(() => 0.5 - Math.random());
            setLetterOrder(shuffled);
            setIndex(0);
        } else {
            setLetterOrder([...randonLetters]);
            setIndex(0);
        }
    }, [type]);

    // Load volume from local storage
    useEffect(() => {
        const savedVolume = localStorage.getItem('tapGameVolume');
        if (savedVolume !== null) {
            setVolume(parseFloat(savedVolume));
        }
    }, []);

    // Speak the current letter
    useEffect(() => {
        if (!completed && letterOrder.length > 0 && !isMuted) {
            const utterance = new SpeechSynthesisUtterance(`Draw letter ${letterOrder[index]}`);
            utterance.rate = 0.9;
            utterance.volume = volume;
            speechSynthesis.speak(utterance);
        }
    }, [index, letterOrder, completed, isMuted, volume]);

    const handleComplete = (isCorrect) => {
        setCompleted(true);
        if (isCorrect) {
            setScore((prev) => prev + 1);
            setMessage('✅ Good job!');
            setScoreAnim(true);
            setTimeout(() => setScoreAnim(false), 700);
        } else {
            setMessage('❌ Try again!');
        }
        setTimeout(() => {
            setCompleted(false);
            setMessage('');
            if (isCorrect) {
                if (index < letterOrder.length - 1) {
                    setIndex(index + 1);
                } else {
                    setMessage('🎉 All letters completed!');
                }
            }
        }, 1200);
    };

    // Get current letter and letter data
    const currentLetter = letterOrder[index];
    const letterIdx = randonLetters.indexOf(currentLetter);

    return (
        <div className="tap-letter-board-bg">
            <div className="tap-header-bar mb-1">
                <div className="tap-score-box">
                    <span role="img" aria-label="score" style={{ fontSize: 22, marginRight: 6 }}>🏆</span>
                    <span className="tap-score-label">Score</span>
                    <span className="tap-score-value">{score}/{letterOrder.length}</span>
                </div>
                <div className="tap-letter-target">
                    <span className="tap-letter-label">Draw letter:</span>
                    <span className="tap-letter-value">{currentLetter}</span>
                </div>
                <div className="tap-volume-box">
                    <span role="img" aria-label="volume" style={{ fontSize: 20, marginRight: 4 }}>🔊</span>
                    <input
                        id="volume"
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={volume}
                        onChange={e => {
                            const newVol = parseFloat(e.target.value);
                            setVolume(newVol);
                            localStorage.setItem('tapGameVolume', newVol);
                        }}
                        style={{ width: '90px', verticalAlign: 'middle' }}
                    />
                    <span className="tap-volume-value">{Math.round(volume * 100)}%</span>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary ms-2"
                        style={{ borderRadius: 12, padding: '2px 8px', marginLeft: 8 }}
                        title="Replay Letter"
                        onClick={() => {
                            if (currentLetter && !isMuted) {
                                const utterance = new window.SpeechSynthesisUtterance(`Draw letter ${currentLetter}`);
                                utterance.rate = 0.9;
                                utterance.volume = volume;
                                window.speechSynthesis.speak(utterance);
                            }
                        }}
                    >
                        <span className="material-symbols-outlined" style={{ fontSize: 20, verticalAlign: 'middle' }}>replay</span>
                    </button>
                </div>
            </div>
            <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <p className={scoreAnim ? 'score-pop' : ''} style={{ fontSize: 18, fontWeight: 500 }}>
                    {/* Score already shown in header */}
                </p>
                {letterIdx !== -1 && (
                    <LetterCanvas
                        image={letters[letterIdx].image}
                        strokes={letters[letterIdx].strokes}
                        onComplete={handleComplete}
                        completed={completed}
                    />
                )}
                <h2>{message}</h2>
            </div>
            <style>
                {`
          .tap-letter-board-bg {
            background: url('/image/board.png'), linear-gradient(135deg,rgba(62, 62, 62, 0.3) 0%,rgba(15, 15, 14, 0.41) 100%);
            background-size: cover, cover;
            background-position: center, center;
            border-radius: 32px;
            box-shadow: 0 6px 32px #e0c68a33;
            padding: 32px 12px 24px 12px;
            margin: 0 auto;
            max-width: 900px;
            width: 98%;
            min-height: 400px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 2;
            animation: board-pop 0.5s cubic-bezier(.68,-0.55,.27,1.55);
          }
          @keyframes board-pop {
            0% { transform: scale(0.9); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          .tap-header-bar {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 20px;
            box-shadow: 0 2px 8px rgba(224,198,138,0.10);
            padding: 1px 18px 18px 18px;
            margin-bottom: 18px;
            gap: 0;
          }
          .tap-score-box,
          .tap-volume-box {
            display: flex;
            align-items: center;
            border-radius: 14px;
            padding: 6px 14px;
            font-weight: 700;
            font-size: 1.1rem;
            color: #b8860b;
            background: rgba(255, 255, 255, 0.86);
            min-width: 110px;
            box-shadow: 0 1px 4px rgba(224,198,138,0.10);
          }
          .tap-score-label {
            margin-right: 6px;
            font-size: 1rem;
            color: #b8860b;
          }
          .tap-score-value {
            font-size: 1.1rem;
            color: #1976d2;
            margin-left: 4px;
            font-weight: 700;
          }
          .tap-letter-target {
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(224,198,138,0.92);
            border-radius: 18px;
            padding: 8px 32px;
            box-shadow: 0 1px 4px rgba(224,198,138,0.10);
            margin: 0 18px;
            min-width: 180px;
          }
          .tap-letter-label {
            font-size: 1.1rem;
            color: #3e2723;
            margin-right: 8px;
            font-weight: 600;
          }
          .tap-letter-value {
            font-size: 2rem;
            color: #1976d2;
            font-weight: 900;
            letter-spacing: 2px;
            text-shadow: 1px 1px 8px #fff, 0 0 8px #e0c68a;
          }
          .tap-volume-value {
            margin-left: 8px;
            font-size: 1rem;
            color: #1976d2;
            font-weight: 700;
            min-width: 36px;
            display: inline-block;
            text-align: right;
          }
          .score-pop {
            animation: correct-pop 0.5s;
          }
          @keyframes correct-pop {
            0% { transform: scale(1.15); }
            100% { transform: scale(1); }
          }
          @media (max-width: 1024px) {
            .tap-letter-board-bg {
              max-width: 99vw;
              padding: 18px 2vw 18px 2vw;
              min-height: 260px;
            }
          }
          @media (max-width: 700px) {
            .tap-header-bar {
              flex-direction: column;
              gap: 10px;
              padding-bottom: 10px;
            }
            .tap-letter-target {
              min-width: 0;
              width: 100%;
              padding: 8px 0;
              margin: 8px 0;
            }
            .tap-letter-board-bg {
              padding: 10px 2vw 10px 2vw;
              min-height: 180px;
            }
          }
          @media (max-width: 480px) {
            .tap-letter-board-bg {
              padding: 6px 1vw 6px 1vw;
              min-height: 120px;
            }
            .tap-header-bar {
              padding: 6px 4px 6px 4px;
            }
          }
        `}
            </style>
        </div>
    );
};

export default LetterDrawingComp;